import axios from "axios";
// import router from '../router/index'
// 导入loading Loading 服务
// import { Message } from 'element-ui'
// import {BASE_URL, TIME_OUT } from './config' //不同环境的请求配置
// let url = 'http://111.0.83.194:48081'    //本地环境 王赟
// let url = 'http://192.168.1.124:48080'    //本地环境 王路
// let url = 'http://59.111.125.195:48080/'  //测试环境(服务器停用了)
// let url = 'https://xhsz-ai.com/sz-api/'  //新的正式环境
  //  let url = 'http://106.12.51.46:48080/' //旧的正式环境
let url = 'http://111.0.107.63:8031' //本地环境 李臣权
// let url = 'http://39.174.160.222:8031' //本地环境 李臣权
let num = true  //防止重复跳转
export function request(config) {
  const service = axios.create({
    baseURL: url, //配置公共接口
    timeout: 600000 //配置请求超时时间 
  })
  // // 请求拦截器
  service.interceptors.request.use(config => {
    // let token = JSON.parse(localStorage.getItem('loginstate'))
    // if (token) {
    //   config.headers.Authorization = "Bearer " + token.accessToken
    // }
    // //这里可以做token 设置
    return config
  }, err => { })

  // // 响应拦截器
  service.interceptors.response.use(res => {
    // if (res.data.code == 200) {
    // } else if (res.data.code == 401) {
    //   if(num){
    //     localStorage.removeItem("loginstate")
    //     Message({
    //       message: '未授权，请重新登录',
    //       center: true
    //     })
    //     setTimeout(() => {
    //       redirectLogin()
    //     }, 1000);
    //     num = false
    //   }
    // }
    return res

  }, err => {
    return err
  })
  return service(config)

}
const jyRquest = {
  //  post 封装请求
  post(config) {
    return request({ ...config, method: 'POST' })
  },
  get(config) {
    return request({ ...config, method: 'GET' })
  },
  put(config) {
    return request({ ...config, method: 'PUT' })
  },
  patch(config) {
    return request({ ...config, method: 'PATCH' })
  },
  delete(config) {
    return request({ ...config, method: 'DELETE' })
  },
}
function redirectLogin() {
  num = true
  router.replace('/login')
  window.location.reload();
  return
}

export default jyRquest